<template>
<div class="chapter">
<div class="inner_page">
<div class="epigraphPage" id="epi">
<a id="page09">
<div class="epigraph">
<p class="epigraphTextleft">Some say the world will end in fire,</p>
<p class="epigraphTextleft"> Some say in ice.</p>
<p class="epigraphSourceright">—<span class="smallCaps">ROBERT FROST</span></p>
</div>
</a><a id="page10">
</a><a id="page11">
</a><a id="page12">
</a></div>
<a id="page12">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// icemaidenthe_epi.vue?2cc11a51